import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    InputBase,
    Paper,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { darkBlue2, white } from '@styles/colors';
import { Helmet } from 'react-helmet';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import AddTemplateModal from '@features/enterprise/components/AddTemplateModal';
import SingleTemplateRow from '@features/enterprise/components/SingleTemplateRow';
import { useGetTemplates } from '@features/enterprise/hooks/useGetTemplates';
import { EnterpriseTemplate } from '@features/enterprise/types';
import TemplatesDropdownModal from '@features/enterprise/components/TemplatesDropdownModal';

function EnterpriseTemplates() {
    const [searchValue, setSearchValue] = useState('');
    const [errorText, setErrorText] = useState('');
    const [showAddTampleteModal, setShowAddTampleteModal] = useState(false);
    const [showInviteCompanyModal, setShowInviteCompanyModal] = useState(false);
    const [statusValue, setStatusValue] = useState<number>(0);
    const { templatesList, isLoadingTemplatesList } = useGetTemplates({
        setErrorText,
        searchValue: searchValue.length > 3 ? searchValue : '',
        status: statusValue
    });

    return (
        <>
            <Helmet>
                <title>Template | StaffedUp</title>
            </Helmet>
            <Stack component="section" spacing={5} pt={5} pb={4} px={3} pl={6}>
                <Stack
                    p={3}
                    borderRadius="8px"
                    bgcolor={white}
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                >
                    <Typography variant="h3" fontSize="28px" fontWeight="bold">
                        Company Templates
                    </Typography>
                    <ToggleButtonGroup
                        value={statusValue}
                        exclusive
                        onChange={(event, newValue) => {
                            setStatusValue(newValue);
                        }}
                    >
                        <ToggleButton
                            sx={{
                                backgroundColor: statusValue === 0 ? darkBlue2 : 'default',
                                color: statusValue === 0 ? 'white' : 'default',
                                '&.Mui-selected': {
                                    backgroundColor: darkBlue2,
                                    color: 'white',
                                },
                                padding: "5px 30px", borderBottomLeftRadius: '5px', borderTopLeftRadius: '5px'
                            }}
                            disabled={statusValue === 0}
                            value={0}>Active
                        </ToggleButton>

                        <ToggleButton sx={{
                            backgroundColor: statusValue == 1 ? darkBlue2 : 'default',
                            color: statusValue == 1 ? 'white' : 'default',
                            '&.Mui-selected': {
                                backgroundColor: darkBlue2,
                                color: 'white',
                            },
                            padding: "5px 30px", borderBottomRightRadius: '5px', borderTopRightRadius: '5px'
                        }}
                            disabled={statusValue === 1}

                            value={1}>
                            Archive
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
                <Stack
                    spacing={4}
                    sx={{ borderRadius: 5 }}
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent={{ sm: 'space-between' }}
                    alignItems="center"
                >
                    <Paper
                        component="form"
                        sx={{
                            pl: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            maxWidth: 400,
                            width: '100%',
                            borderRadius: 5,
                        }}
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search"
                            inputProps={{ 'aria-label': 'search' }}
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                            }}
                            style={{ borderRadius: 5 }}
                        />
                        <IconButton type="button" sx={{ px: '10px' }} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                    <Stack direction='row' spacing={2}>
                        {/* {templatesList && templatesList?.object?.length > 0 && statusValue === 0 && (
                            <Button
                                onClick={() => setShowInviteCompanyModal(true)}
                                startIcon={<AddIcon />}
                                variant="outlined"
                                sx={{ mt: 2, width: { sm: '100%', lg: '200px' } }}
                            >
                                Invite Companies
                            </Button>
                        )} */}
                        <Button
                            onClick={() => setShowAddTampleteModal(true)}
                            startIcon={<AddIcon />}
                            variant="contained"
                            sx={{ mt: 2, width: { sm: '100%', lg: '200px' } }}
                        >
                            Add Template
                        </Button>
                    </Stack>
                </Stack>
                <Stack spacing={3} component="ul" sx={{ p: 0 }}>
                    {isLoadingTemplatesList ? (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                alignSelf: 'center',
                                width: 'auto',
                                height: '150px',
                                margin: 'auto',
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : templatesList && templatesList?.object?.length > 0 ? (
                        templatesList?.object?.map((item: EnterpriseTemplate) => {
                            return <SingleTemplateRow item={item} />;
                        })
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                alignSelf: 'center',
                                width: 'auto',
                                height: '150px',
                                margin: 'auto',
                            }}
                        >
                            <Typography>No Data Found</Typography>
                        </Box>
                    )}
                </Stack>
                {showAddTampleteModal && (
                    <AddTemplateModal
                        handleClose={
                            () => setShowAddTampleteModal(false)}
                    />
                )}
                {showInviteCompanyModal && (
                    <TemplatesDropdownModal
                        handleClose={() => setShowInviteCompanyModal(false)}
                    />
                )}
            </Stack>
        </>
    );
}

export default EnterpriseTemplates;
